export enum GenderEnum {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
}

export enum VerificationTypesEnum {
	IDENTITY = 'IDENTITY',
	PROFILE_PHOTO = 'PROFILE_PHOTO',
	BIO = 'BIO',
}

export enum UserAccountStatusEnum {
	ACTIVE = 'ACTIVE',
	HIDDEN = 'HIDDEN',
	PAUSED = 'PAUSED',
	DELETED = 'DELETED',
	BANNED = 'BANNED',
	SUSPENDED = 'SUSPENDED',
	ADMIN_DELETED = 'ADMIN_DELETED',
}

export enum VerifStatusEnum {
	DENIED = 'DENIED',
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
}

export enum AdminUserPermissionsEnum {
	CERTIFICATION = 'CERTIFICATION',
	PHOTO_VERIF = 'PHOTO_VERIF',
	BIO_VERIF = 'BIO_VERIF',
	REPORT = 'REPORT',
	STATS = 'STATS',
	USERS = 'USERS',
	REFERRAL = 'REFERRAL',
	HISTORY = 'HISTORY',
	REFERRAL_DELETE = 'REFERRAL_DELETE',
	PROFILE_DETAIL_ACTIONS = 'PROFILE_DETAIL_ACTIONS',
	SETTINGS = 'SETTINGS',
	ACCOUNTING_OVERVIEW = 'ACCOUNTING_OVERVIEW',
	ACCOUNTING_MANAGER = 'ACCOUNTING_MANAGER',
	ADD_REMOVE_USER_COINS = 'ADD_REMOVE_USER_COINS',
	ADD_REMOVE_USER_INCOGNITO = 'ADD_REMOVE_USER_INCOGNITO',
	ADD_REMOVE_USER_BOOST = 'ADD_REMOVE_USER_BOOST',
	HANDLE_ADMIN_REVIEW_REQUEST = 'HANDLE_ADMIN_REVIEW_REQUEST',
	USERS_SUB_ACCOUNTS = 'USERS_SUB_ACCOUNTS',
	USERS_TRANSACTIONS = 'USERS_TRANSACTIONS',
	USERS_PAYMENTS = 'USERS_PAYMENTS',
	SEND_ADMIN_MESSAGES = 'SEND_ADMIN_MESSAGES',
	MARKETING = 'MARKETING',
	PROMOTION = 'PROMOTION',
	EVENT = 'EVENT',
	SUSPEND_USER = 'SUSPEND_USER',
	BULK_NOTIFICATIONS = 'BULK_NOTIFICATIONS',
	PAYMENT_PACKAGES = 'PAYMENT_PACKAGES',
	PAYMENT_PROVIDERS = 'PAYMENT_PROVIDERS',
	PAYMENT_METHOD_REQUESTS = 'PAYMENT_METHOD_REQUESTS',
}

export enum AdminUpdateActionEnum {
	WARN = 'WARN',
	REMOVE_BIO = 'REMOVE_BIO',
	CHANGE_GENDER = 'CHANGE_GENDER',
	REQUEST_CERTIF = 'REQUEST_CERTIF',
	REMOVE_CERTIFICATION = 'REMOVE_CERTIFICATION',
}

export enum BanTypeEnum {
	DEVICE_BAN = 'DEVICE_BAN',
	EMAIL_BAN = 'EMAIL_BAN',
}

export enum PhotoGridPositionsEnum {
	CERTIF = 'certif',
	CENTER = 'center',
	RIGHT1 = 'right1',
	RIGHT2 = 'right2',
	BOTTOM1 = 'bottom1',
	BOTTOM2 = 'bottom2',
	BOTTOM3 = 'bottom3',
}
